<template>
  <base-container ref="container" style="height: 100%; padding: 5px">
    <el-tabs
      type="border-card"
      v-model="tabName"
      style="height: calc(100% - 7px)"
      tab-position="left"
    >
      <el-tab-pane
        :label="userHosDept.name"
        :name="userHosDept.id"
        v-for="userHosDept in userHosDepts"
        :key="userHosDept.id"
      >
        <ResourceOfHos :hosId="userHosDept.id" :hosDepts="userHosDept.depts"></ResourceOfHos>
      </el-tab-pane>
    </el-tabs>
  </base-container>
</template>

<script>
import { getUserHosDepts } from "@/api/jc/dept";
import ResourceOfHos from "./ResourceOfHos.vue";
export default {
  components: { ResourceOfHos },
  data() {
    return {
      userHosDepts: [],
      tabName: "",
    };
  },
  created() {
    getUserHosDepts().then((res) => {
      this.userHosDepts = res.data.data;
      this.tabName = this.userHosDepts[0].id;
    });
  },
  methods: {},
};
</script>

<style scoped>
::v-deep .el-tabs__content {
  height: 100%;
  padding: 10px 0;
}
::v-deep .el-tab-pane {
  height: 100%;
}
</style>